export function usarUrl() {
  const pegarQueryStringDaRota = (rota: string) => {
    return rota.split("?")[1]
  }

  const converterQueryStringParaObjeto = (queryString: string) => {
    const parametrosUrl = new URLSearchParams(queryString)
    const entradas = parametrosUrl.entries()

    return converterEntradasParaObjeto(entradas)
  }

  const converterEntradasParaObjeto = (
    entradas: IterableIterator<[string, string]>
  ) => {
    const resultado = {}
    for (const [chave, valor] of entradas) {
      resultado[chave] = valor
    }

    return resultado
  }

  return {
    converterQueryStringParaObjeto,
    pegarQueryStringDaRota,
  }
}
